/* eslint-disable @typescript-eslint/return-await */
import { client } from '@/Prismic.js';
import * as prismic from '@prismicio/client';

export const getSingle = async ([type, params]) => await client.getSingle(type, params);

export const getAllByType = async ([type, params]) => await client.getAllByType(type, params);

export const getAllByTag = async ([tag, params]) => await client.getAllByTag(tag, params);

// Filters usage example: https://prismic.io/docs/technical-reference/prismicio-client#query-filters
export const getByFilter = async ([filters, params]) =>
    await client.get({
        filters: Object.keys(filters).map((item) => prismic.filter.at(item, filters[item])),
        ...params,
    });

// Like getByFilter but fetches all pages. Returns { results: [...] } for compatibility.
export const getAllByFilter = async ([filters, params]) => {
    const mappedFilters = Object.keys(filters).map((item) => prismic.filter.at(item, filters[item]));
    const firstPage = await client.get({ filters: mappedFilters, ...params, pageSize: 100, page: 1 });
    if (firstPage.total_pages <= 1) return { results: firstPage.results };

    const remaining = await Promise.allSettled(
        Array.from({ length: firstPage.total_pages - 1 }, (_, i) =>
            client.get({ filters: mappedFilters, ...params, pageSize: 100, page: i + 2 })
        )
    );

    const fulfilledResults = remaining.flatMap((p) => {
        if (p.status === 'rejected') {
            console.error('[getAllByFilter] failed to fetch a page:', p.reason);
            return [];
        }
        return p.value.results;
    });

    return { results: [...firstPage.results, ...fulfilledResults] };
};
